import "./DrawingComponent.css";
import { useEffect, useRef, useState } from "react";
import HomeComponent from "../HomeComponent/HomeComponent";

const DrawingComponent = () => {
    const canvasRef = useRef(null);
    const contextRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const penWidth = 5; // Increased pen width for better visibility on mobile

    const getPos = (event) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;

        let clientX, clientY;

        if (event.touches) {
            clientX = event.touches[0].clientX;
            clientY = event.touches[0].clientY;
        } else {
            clientX = event.clientX;
            clientY = event.clientY;
        }

        return {
            offsetX: (clientX - rect.left) * scaleX,
            offsetY: (clientY - rect.top) * scaleY
        };
    };

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        context.lineCap = "round";
        context.strokeStyle = "red";
        context.lineWidth = penWidth;
        contextRef.current = context;

        const resizeCanvas = () => {
            const parent = canvas.parentElement;
            canvas.width = parent.clientWidth;
            canvas.height = parent.clientWidth; // Keep square
        };

        resizeCanvas();
        window.addEventListener("resize", resizeCanvas);

        return () => {
            window.removeEventListener("resize", resizeCanvas);
        };
    }, []);

    const startDrawing = (event) => {
        event.preventDefault(); // Prevent scrolling on mobile
        const { offsetX, offsetY } = getPos(event);
        contextRef.current.lineWidth = penWidth;
        contextRef.current.beginPath();
        contextRef.current.moveTo(offsetX, offsetY);
        setIsDrawing(true);
    };

    const draw = (event) => {
        if (!isDrawing) return;
        event.preventDefault();
        const { offsetX, offsetY } = getPos(event);
        contextRef.current.lineTo(offsetX, offsetY);
        contextRef.current.stroke();
    };

    const stopDrawing = () => {
        contextRef.current.closePath();
        setIsDrawing(false);
    };

    const setToDraw = () => {
        contextRef.current.globalCompositeOperation = "source-over";
    };

    const setToErase = () => {
        contextRef.current.globalCompositeOperation = "destination-out";
    };

    const clearCanvas = () => {
        const canvas = canvasRef.current;
        contextRef.current.clearRect(0, 0, canvas.width, canvas.height);
    };

    const saveImageToLocal = (event) => {
        let link = event.currentTarget;
        link.setAttribute("download", "canvas.png");
        let image = canvasRef.current.toDataURL("image/png");
        link.setAttribute("href", image);
    };

    return (
        <div className="canvas-wrapper">
            <div className="canvas-container">
                <canvas
                    ref={canvasRef}
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                    onTouchStart={startDrawing}
                    onTouchMove={draw}
                    onTouchEnd={stopDrawing}
                />
            </div>
            <div>
                <button onClick={setToDraw}>Draw</button>
                <button onClick={setToErase}>Erase</button>
                <button onClick={clearCanvas}>Clear</button>
                <a id="download_image_link" href="download_link" onClick={saveImageToLocal}>
                    Download Image
                </a>
            </div>
            <div>
                <HomeComponent />
            </div>
        </div>
    );
};

export default DrawingComponent;
